<template>
	<div>
		<ListHeaderComponent :background="background" :black="true">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>

		<form action="" class="account">
			<div class="container">
				<h3 class="account__headline">{{$t('account.basics.header')}} *</h3>

				<div class="account__wrapper">
					<div class="account__wrapper account__wrapper--row">
						<div class="account__wrapper account__wrapper--col">
							<input class="account__input account__input--name" type="text"
								   :placeholder="data.first_name" v-model="data.first_name">
							<span class="account__error">{{error.name}}</span>
						</div>
						<div class="account__wrapper account__wrapper--col">
							<input class="account__input account__input--lastName" type="text"
								   :placeholder="data.last_name" v-model="data.last_name">
							<span class="account__error">{{error.last_name}}</span>
						</div>
					</div>
					<div class="account__wrapper account__wrapper--col">
						<input class="account__input account__input--long account__input--email" type="text"
							   :placeholder="data.email" v-model="data.email">
						<span class="account__error">{{error.email}}</span>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12 col-lg-11">
						<span class="account__obligatory">* {{$t('account.obligatory')}}</span>
						<div class="account__divider"></div>
					</div>
				</div>

				<h3 class="account__headline">{{$t('account.adress.header')}}</h3>


				<div class="row">
					<div class="col-sm-12 col-xl-11 col-11--flex">
						<div class="account__wrapper">
							<input class="account__input account__input--long account__input--street" type="text"
								   :placeholder="$t('account.adress.street')" v-model="data.street">
							<div class="account__wrapper account__wrapper--row">
								<!--<input class="account__input account__input&#45;&#45;mid account__input&#45;&#45;city" type="text" placeholder="City">-->
								<input type="text"
									   ref="autocomplete"
									   :placeholder="$t('account.adress.city')"
									   v-model="city"
									   class="account__input account__input--mid account__input--city"
								>

								<input class="account__input account__input--short account__input--postal" type="text"
									   :placeholder="$t('account.adress.post')" v-model="data.postal_code">
							</div>

							<div class="filter__wrapper">
								<input type="text"
									   :placeholder="$t('account.adress.country')"
									   class="account__input account__input--long account__input--country"
									   :class="{open: 'country' === showList, close: 'country' !== showList}"
									   @click="updateShowList('country')"
									   @input="showList = 'country'"
									   v-model="searchByCountry"
								>
								<ul v-show="'country' === showList"
									class="filter__list"
								>
									<li class="filter__list-item" @click="removeCountry">{{$t('account.adress.remove')}}</li>
									<li class="filter__list-item"
										v-for="country in countryList"
										@click="selectCountry(country)"
										:class="{'filter__list-item--active': activeCountry === country.code}"
									>
										{{country.name}}
									</li>
								</ul>
							</div>
						</div>
						<span class="account__info">
							{{$t('account.adress.description')}}
						</span>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12 col-lg-11">
						<div class="account__divider"></div>
					</div>
				</div>

				<h3 class="account__headline">{{$t('account.breeds.header')}}</h3>

				<div class="row">
					<div class="col-sm-12 col-xl-11 col-11--flex">
						<div class="account__wrapper account__wrapper--breed">

							<div v-for="(breed, index) in myBreeds" class="filter__wrapper">
								<input class="comment__input comment__input--breed account__input account__input--breed"
									   :class="{open: `breed-${index}` === showList, close: `breed-${index}` !== showList}"
									   @click="updateShowList(`breed-${index}`)"
									   @input="showList = `breed-${index}`"
									   :placeholder="$t('account.breeds.breed')"
									   v-model="breed.name"
								>
								<ul v-show="`breed-${index}` === showList"
									class="filter__list"
								>
									<li class="filter__list-item" @click="removeBreed(breed)">{{$t('account.breeds.remove')}}</li>
									<li class="filter__list-item"
										v-for="item in breedsList(breed.name)"
										@click="selectBreed(item, breed)"
										:class="{'filter__list-item--active': breed.name === item.name}"
									>
										{{item.name}}
									</li>
								</ul>
							</div>
						</div>
						<span class="account__info">
							{{$t('account.breeds.description')}}
						</span>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 col-lg-11 col-11--flex">
						<div @click="addBreedFilter" class="account__plus"><img src="/static/img/plus.svg" alt=""></div>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12 col-lg-11">
						<div class="account__divider"></div>
					</div>
				</div>

				<h3 class="account__headline">Password</h3>

				<div class="row">
					<div class="col-sm-12 col-lg-11 col-11--flex">
						<div class="account__wrapper">
							<input class="account__input account__input--long account__input--password" type="password"
								   :placeholder="$t('account.password.pass')" v-model="password">
							<span class="account__error">{{error.password}}</span>
							<div class="account__wrapper account__wrapper--row">
								<div class="account__wrapper account__wrapper--col">
									<input class="account__input account__input--new-password" type="password"
										   :placeholder="$t('account.password.newPass')" v-model="newPassword">
									<span class="account__error">{{error.newPassword}}</span>
								</div>
								<div class="account__wrapper account__wrapper--col">
									<input class="account__input account__input--new-password-confirmed" type="password"
										   :placeholder="$t('account.password.newPassConfirmation')" v-model="newPasswordConfirmation">
									<span class="account__error">{{error.newPasswordConfirmation}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- <h4 class="account__terms-headline">Terms and conditions apply:</h4>
					<span class="account__terms-headline account__terms-headline--regular">By clicking Create an Account you agree to our Terms and conditions and our Cookie policy.</span>

					<label class="filter__label">
						<input class="filter__input filter__input--agree" checked data-agreement="first" required type="checkbox">
						<span class="filter__checkbox">
							<span class="filter__checkbox--bg"></span>
						</span>
						Lorem ipsum dolor sit amet, consectetuer adipiscing elit. *
					</label>


					<label class="filter__label">
						<input class="filter__input filter__input--agree" checked data-agreement="second" required type="checkbox">
						<span class="filter__checkbox">
							<span class="filter__checkbox--bg"></span>
						</span>
						Lorem ipsum dolor sit amet, consectetuer adipiscing elit. *
					</label>


					<label class="filter__label">
						<input class="filter__input filter__input--agree" checked data-agreement="third" required type="checkbox">
						<span class="filter__checkbox">
							<span class="filter__checkbox--bg"></span>
						</span>
						Lorem ipsum dolor sit amet, consectetuer adipiscing elit. *
					</label>
					<span class="account__error">{{error.agreements}}</span>

					<div class="row">
						<div class="col-11">
							<span class="account__obligatory">* Obligatory fields</span>
						</div>
					</div> -->

				<div class="row">
					<div class="col-sm-12 col-lg-11 col-11--flex">
						<button class="account__btn" @click="updateAccount($event)">{{$t('account.update')}}</button>
					</div>
				</div>

			</div>
		</form>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	/* global google */
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'
	import router from '@/router'
	import axios from 'axios'

	export default {
		components: {
			ListHeaderComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: this.$t('account.my'),
				background: 'account',
				error: {
					name: '',
					last_name: '',
					email: '',
					password: '',
					newPassword: '',
					newPasswordConfirmation: '',
					confirmedPassword: '',
					agreements: ''
				},
				showList: '',
				searchByBreed: '',
				activeBreed: '',
				breeds: [],
				myBreeds: [
					{
						name: '',
						id: ''
					},
					{
						name: '',
						id: ''
					},
					{
						name: '',
						id: ''
					},
					{
						name: '',
						id: ''
					}
				],
				data: {
					first_name: this.$t('account.basics.name'),
					last_name: this.$t('account.basics.lastName'),
					email: this.$t('account.basics.email'),
					street: this.$t('account.adress.street'),
					city: this.$t('account.adress.city'),
					postal_code: this.$t('account.adress.post'),
					country: this.$t('account.adress.country')
				},
				searchByCountry: '',
				activeCountry: '',
				countries: [],
				city: '',
				cityID: '',
				password: '',
				newPassword: '',
				newPasswordConfirmation: ''
			}
		},
		methods: {
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			scrollTop () {
				this.$scrollTo('body', 1, {})
			},
			passwordValidation (password, confirmedPassword) {
				if (password === confirmedPassword) {
					return true
				} else {
					this.error.newPasswordConfirmation = this.$t('errors.confirmedPassword')
				}
			},
			clearErrors () {
				this.error.name = ''
				this.error.last_name = ''
				this.error.email = ''
				this.error.password = ''
				this.error.confirmedPassword = ''
				this.error.agreements = ''
				this.error.main = false
				this.error.newPassword = ''
				this.error.newPasswordConfirmation = ''
			},
			agreementsValidation (agreements) {
				const error = [...agreements].find(agreement => agreement.checked === false)
				if (error) {
					this.error.agreements = this.$t('errors.agreements')
				} else {
					this.clearErrors()
					return true
				}
			},
			updateAccount (event) {
				event.preventDefault()
				const { password, newPassword, newPasswordConfirmation, selectedBreeds } = this
				if (this.passwordValidation(newPassword, newPasswordConfirmation)) {
					this.clearErrors()
					let data
					if (password || newPassword) {
						data = {
							first_name: this.data.first_name,
							last_name: this.data.last_name,
							email: this.data.email,
							street: this.data.street,
							postal_code: this.data.postal_code,
							city: this.cityID,
							country: this.activeCountry,
							breeds: selectedBreeds,
							old_password: password,
							new_password: newPassword
						}
					} else {
						data = {
							first_name: this.data.first_name,
							last_name: this.data.last_name,
							email: this.data.email,
							street: this.data.street,
							postal_code: this.data.postal_code,
							city: this.cityID,
							country: this.activeCountry,
							breeds: selectedBreeds
						}
					}
					axios.put('/api/user/account/', data, {
						headers: {
							'accept': 'application/json'
						}
					})
						.then(response => {
							router.push('/')
						})
						.catch(error => {
							if (error.response.status === 401) {
								this.error.main = error.response.data.detail
							}
							if (error.response.status === 400) {
								if (error.response.data.name) {
									this.error.name = error.response.data.name[0]
								}
								if (error.response.data.last_name) {
									this.error.last_name = error.response.data.last_name[0]
								}
								if (error.response.data.email) {
									this.error.email = error.response.data.email[0]
								}
								if (error.response.data.old_password) {
									this.error.password = error.response.data.old_password[0]
								}
								if (error.response.data.new_password) {
									this.error.newPassword = error.response.data.new_password[0]
								}
							}
						})
				}
			},
			fetchAccount () {
				axios.get('/api/user/account/', {})
					.then(response => {
						const breeds = response.data.breeds || []
						const breedsNames = response.data.breeds_names || []
						this.data = response.data
						this.searchByCountry = response.data.country_detail && response.data.country_detail.name
						this.activeCountry = response.data.country_detail && response.data.country_detail.code
						this.city = response.data.city_detail && response.data.city_detail.name
						this.cityID = response.data.city
						breeds.forEach((breed, i) => {
							this.myBreeds[i].id = breed
							this.myBreeds[i].name = breedsNames[i]
						})
					})
					.catch(error => {
						console.error(error)
					})
			},
			selectBreed (item, breed) {
				breed.name = item.name
				breed.id = item.id
				this.showList = ''
			},
			removeBreed (breed) {
				breed.name = ''
				breed.id = ''
			},
			fetchBreeds () {
				axios.get('/api/dogs/subgroup/autocomplete/', {})
					.then(response => {
						this.breeds = response.data
					})
					.catch(error => {
						console.error(error)
					})
			},
			addBreedFilter () {
				this.myBreeds.push({
					name: '',
					id: ''
				})
			},
			selectCountry (country) {
				this.searchByCountry = country.name
				this.activeCountry = country.code
				this.showList = ''
			},
			removeCountry () {
				this.searchByCountry = ''
				this.activeCountry = ''
			},
			fetchUserCountries () {
				axios.get('/api/places/countries/autocomplete/', {})
					.then(response => {
						this.countries = response.data
					})
					.catch(error => {
						console.error(error)
					})
			},
			selectPlace (place) {
				this.city = place.address_components[0].long_name
				this.cityID = place.place_id
			}
		},
		computed: {
			breedsList () {
				return breedName => {
					const inputTest = breed => {
						if (!this.selectedBreeds.find(selected => selected === breed.id)) {
							const regExp = new RegExp('^' + breedName, 'i')
							return regExp.test(breed.name)
						}
					}
					return this.breeds.filter(inputTest)
				}
			},
			selectedBreeds () {
				return this.myBreeds.reduce((acc, breed) => {
					return breed.id ? [...acc, breed.id] : acc
				}, [])
			},
			countryList () {
				const inputTest = country => {
					const regExp = new RegExp('^' + this.searchByCountry, 'i')
					return regExp.test(country.name)
				}
				return this.countries.filter(inputTest)
			}
		},
		mounted () {
			const options = {
				types: [
					'(cities)'
				]
			}
			this.autocomplete = new google.maps.places.Autocomplete(
				(this.$refs.autocomplete),
				options
			)
			this.autocomplete.addListener('place_changed', () => {
				const place = this.autocomplete.getPlace()
				this.selectPlace(place)
			})
		},
		created () {
			this.fetchAccount()
			this.scrollTop()
			this.fetchBreeds()
			this.fetchUserCountries()
			window.addEventListener('click', this.closeFlitersLists)
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>

	@import "../styles/variables.scss";

	.empty-filter {
		width: 100%;
		height: 35px;
		background-color: $gold-light;
	}

	.account {
		padding-top: 45px;
		padding-bottom: 220px;
		&__headline {
			text-align: left;
			font-family: $lato-bold;
			font-size: 20px;
			letter-spacing: 0.05em;
			text-transform: uppercase;
			margin: 0 0 20px;
		}
		&__wrapper {
			width: 750px;
			display: flex;
			flex-flow: column;
			justify-content: space-between;
			margin-right: 20px;
			&--row {
				flex-flow: row;
			}
			&--col {
				align-items: flex-start;
				justify-content: flex-start;
			}
			&--breed {
				width: 100%;
				min-width: 750px;
				max-width: 750px;
				flex-flow: row;
				flex-wrap: wrap;
			}
		}
		&__input {
			font-size: 16px;
			width: 365px;
			height: 65px;
			background-color: $gray-input;
			padding-left: 25px;
			border: none;
			outline: none;
			margin: 10px 0;
			&--breed {
				margin: 0;
			}
			&--country {
				margin: 0;
			}
			&--short {
				width: 170px;
			}
			&--mid {
				width: 560px;
			}
			&--long {
				width: 750px;
			}
		}
		&__error {
			display: block;
			color: darkred;
			font-size: 13px;
			text-align: left;
		}
		&__obligatory {
			display: block;
			text-align: left;
			font-size: 12px;
			color: $gray-darker;
			margin-top: 10px;
			margin-bottom: 35px;
		}
		&__divider {
			width: 100%;
			height: 3px;
			background-color: $black;
			margin: 15px 0 35px;
		}
		&__info {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 0 35px;
			background-color: $brown-dark;
			font-size: 14px;
			max-height: 140px;
			margin-top: 10px;
		}
		&__plus {
			cursor: pointer;
			padding: 0 20px;
			margin-bottom: 20px;
			background: transparent;
			outline: none;
			border: none;
		}
		&__terms-headline {
			margin: 0;
			margin-top: 10px;
			text-align: left;
			font-family: $lato-bold;
			font-size: 16px;
			line-height: 27px;
			&--regular {
				display: block;
				font-family: $lato;
				margin-bottom: 20px;
			}
		}
		&__btn {
			cursor: pointer;
			width: 100%;
			max-width: 295px;
			height: 65px;
			background-color: $black;
			font-family: $lato-bold;
			font-size: 16px;
			letter-spacing: 0.05em;
			color: #fff;
			text-transform: uppercase;
			border: none;
			outline: none;
			margin-top: 15px;
		}
	}

	.col-11 {
		&--flex {
			display: flex;
		}
	}

	.filter {
		cursor: pointer;
		width: 290px;
		height: 40px;
		background-color: #fff;
		border: none;
		outline: none;
		color: $gray-filter;
		font-size: 16px;
		text-align: left;
		padding-left: 15px;
		margin-left: 15px;
		&__wrapper {
			position: relative;
			margin: 10px 0;
		}
		&__list {
			z-index: 5;
			position: absolute;
			width: 100%;
			max-height: 210px;
			overflow: hidden;
			overflow-y: scroll;
			list-style: none;
			background-color: #eae2d5;
			padding: 15px 0;
			margin: 0;
			right: 0;
		}
		&__list-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 99%;
			padding-left: 15px;
			min-height: 30px;
			cursor: pointer;
			font-family: $lato;
			font-size: 13px;
			&:hover, &--active {
				background-color: #fff;
			}
		}
		&__label {
			display: flex;
			align-items: center;
			height: 100%;
			position: relative;
			cursor: pointer;
			width: 100%;
			text-align: left;
			font-family: $lato;
			font-size: 13px;
			-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;
			margin-bottom: 20px;
			input {
				position: absolute;
				opacity: 0;
				cursor: pointer;
			}
			input:checked + .filter__checkbox > .filter__checkbox--bg {
				background-color: $black;
			}
		}
		&__checkbox {
			position: relative;
			height: 16px;
			width: 16px;
			border: 2px solid $black;
			margin-right: 15px;
			&--bg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				display: block;
				width: 8px;
				height: 8px;
			}
		}
	}

	.filter__list::-webkit-scrollbar {
		width: 3px;
	}

	.filter__list::-webkit-scrollbar-thumb {
		background-color: $brown;
	}

	@media (max-width: 991.98px) {
		.account {
			padding-top: 30px;
			padding-bottom: 30px;
			&__headline {
				font-size: 14px;
			}
			&__wrapper {
				width: 100%;
				flex-flow: column;
				order: 2;
				margin: 0;
				&--row {
					flex-flow: column;
				}
				&--breed {
					width: 100%;
					min-width: 100%;
					max-width: 100%;
					flex-flow: row;
					flex-wrap: wrap;
				}
			}
			&__input {
				width: 100%;
				height: 55px;
				margin: 10px 0;
				&--breed {
					width: 100%;
					margin: 0;
				}
				&--country {
					margin: 0;
				}
				&--short {
					width: 100%;
				}
				&--mid {
					width: 100%;
				}
				&--long {
					width: 100%;
				}
			}
			&__btn {
				margin: 0 auto;
			}
			&__obligatory {
				margin-bottom: 25px;
			}
			&__divider {
				width: 100%;
				margin: 15px 0 25px;
			}
			&__info {
				padding: 35px;
				margin: 10px 0;
				order: 1;
			}
			&__plus {
				text-align: left;
				padding: 0 20px;
				margin: 10px 0;
			}
		}
		.filter {
			&__wrapper {
				width: 100%;
			}
		}
		.col-11 {
			&--flex {
				display: flex;
				flex-flow: column;
			}
		}
	}

	@media (min-width: 992px) and (max-width: 1199.98px) {
		.account {
			&__info {
				max-height: 195px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/Account.vue